import {
  HIDE_MENU
} from "../types";


const hideMenu= () => {
  return({type: HIDE_MENU});
};
export default hideMenu;